export { Transportation, type Props } from './index.pc'
export { MobileTransportation } from './index.mobile'
